import React, { useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import InjectionMouldingHyPETMachineCard from "../components/MachineCard";
import InjectionMouldingHeader from "../../components/Header";
import ContentSubHeader from "../../components/ContentSubHeader";
import axiosInstance from "../../utils/axiosInstance";
import { env } from "../../../../env";
import buildBreadCrumbs from "../../utils/buildBreadCrumb";
import { useQuery } from "@tanstack/react-query";
import { useInjectionDataContext } from "../../contexts/InjectionDataContext";
import LoadingIndicator from "../../components/Loading";
import ErrorIndicator from "../../components/Error";
import { random } from "lodash";
import { useSelector } from "react-redux";
import { AppContext } from "../../../../App";

const baseURL = env?.microservice_assetsmgt;

function HyPetMachineView() {
  const { sharedData } = useInjectionDataContext();
  const { selectedPlantForCube }: any = useContext(AppContext);
  const plantList = useSelector((state: any) => state.plantsList);
  const plantName =
  plantList.plants.find((item: any) => item.plant_code === selectedPlantForCube)
  ?.plant_name || "";


  const params = useParams(); // Gets all dynamic path segments
  const location = useLocation();
  const { assetId, tag, parentId, hypetId, hypetChildId, hypetSubChildId, asset } = location.state || {};

  // Extract the dynamic levels from the params
  const { hypet, hypetchild, hypetsubchild } = params;

  // Build breadcrumb hierarchy dynamically
  const pathLevels = [hypet, hypetchild, hypetsubchild].filter(Boolean);

  // Get current page name from the deepest level
  const currentPage = pathLevels[pathLevels.length - 1] || "HyPet";

  // Determine next page in hierarchy
  const previousPage = pathLevels[pathLevels.length - 2];

  const retrieveAssets = async () => {
    const response = await axiosInstance.get(
      `${baseURL}assets?filter=plant_id:oid_eq:${sharedData[0].plantId}&filter=parent_asset:oid_eq:${assetId}&filter=use_case:oid_eq:${sharedData[0].usecaseId}`
    );
    return response.data;
  };

  const {
    data: hypet_assets,
    error,
    isLoading,
  } = useQuery({
    queryKey: [`hypet_assets_${assetId}`],
    queryFn: retrieveAssets,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  if (isLoading)
    return (
      <div>
        <LoadingIndicator text="Loading Hypets Assets....." />
      </div>
    );
  if (error)
    return (
      <div>
        <ErrorIndicator text={`Error Occured : ${error.message}`} />
      </div>
    );

  const appendPaths = {
    2: "machineview",
  };

  const queryParams = {
    1: { aspid: parentId },
  };

  const stateParams = {
    2: {
      assetId: hypetId,
      tag: tag,
      hypetId: hypetId,
      parentId: parentId,
      hypetChildId: hypetChildId,
      hypetSubChildId: hypetSubChildId,
      asset: asset
    },
    3: {
      assetId: hypetChildId,
      tag: tag,
      hypetId: hypetId,
      parentId: parentId,
      hypetChildId: hypetChildId,
      hypetSubChildId: hypetSubChildId,
      asset: asset
    },
  };



  return (
    <>
      <InjectionMouldingHeader
        pageHeader={`${currentPage} - Machine Details`}
        navigationItem={buildBreadCrumbs(
          plantName,
          [
            "HyPETs",
            hypet,
            ...(hypetchild ? [hypetchild] : []),
            ...(hypetsubchild ? [hypetsubchild] : []),
          ],
          appendPaths,
          queryParams,
          stateParams
        )}
      />
      <ContentSubHeader>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InjectionMouldingHyPETMachineCard
              machneIdentity={previousPage || currentPage}
              childAssets={hypet_assets.data}
              tag={tag}
              pathParts={pathLevels}
              machineName={currentPage}
              parentId={parentId}
              hypetId={hypetId}
              assetId={assetId}
              hypetChildId={hypetChildId}
              hypetSubChildId={hypetSubChildId}
              asset={asset}
              params={params}
            />
          </Grid>
        </Grid>
      </ContentSubHeader>
    </>
  );
}

export default HyPetMachineView;

// /* eslint-disable @typescript-eslint/no-unused-expressions */
// import React from "react";
// import InjectionMouldingHyPETMachineCard from "../../components/MachineCard";
// import { Box, Grid } from "@mui/material";
// import { useParams } from "react-router-dom";
// import InjectionMouldingHeader from "../../../components/Header";
// import { useLocation } from "react-router-dom";
// import axiosInstance from "../../../utils/axiosInstance";
// import { env } from "../../../../../env";
// // eslint-disable-next-line react-hooks/rules-of-hooks
// import { useQuery } from "@tanstack/react-query";
// import ContentSubHeader from "../../../components/ContentSubHeader";
// import buildBreadCrumbs from "../../../utils/buildBreadCrumb";
// import { useInjectionDataContext } from "../../../contexts/InjectionDataContext";
// const baseURL = env?.microservice_assetsmgt;

// function HyPetMachineView() {
//   const { sharedData } = useInjectionDataContext();
//   const pageHierarchy = ["Hypet", "HypetChild1", "HypeChild2", "HypeChild3"];
//   const { "*": path } = useParams(); // Get dynamic nested path
//   const pathParts = path ? path.split("/") : []; // Convert path to array
//   const currentPage =
//     pathParts.length === 0 ? "HyPet" : pathParts[pathParts.length - 1]; // Get current page

//   // Next page URL
//   const nextPage = pageHierarchy[pathParts.length];
//   const { hypet, hypetchild } = useParams();
//   const location = useLocation();
//   const { assetId, tag, parentId } = location.state || {};

//   const retrieveAssets = async () => {
//     const response = await axiosInstance.get(
//       `${baseURL}assets?filter=plant_id:oid_eq:${sharedData[0].plantId}&filter=parent_asset:oid_eq:${assetId}&filter=use_case:oid_eq:${sharedData[0].usecaseId}`
//     );
//     return response.data;
//   };
//   const {
//     data: hypet_assets,
//     error,
//     isLoading,
//   } = useQuery({
//     queryKey: [`hypet_assets_${assetId}`],
//     queryFn: retrieveAssets,
//     refetchOnMount: false,
//     refetchOnWindowFocus: false,
//   });
//   if (isLoading) return <div>Fetching assets...</div>;
//   if (error) return <div>An error occurred: {error.message}</div>;

//   return (
//     <>
//       <InjectionMouldingHeader
//         pageHeader={`${hypet} - Machine Details`}
//         navigationItem={buildBreadCrumbs(
//           ["HyPETs", hypet],
//           { aspid: parentId },
//           0
//         )}
//       />
//       <ContentSubHeader>
//         <Grid container spacing={1}>
//           <Grid item xs={12} sm={12} md={12} lg={12}>
//             <InjectionMouldingHyPETMachineCard
//               machneIdentity={hypet}
//               childAssets={hypet_assets.data}
//               tag={tag}
//               pathParts={pathParts}
//               machineName={hypet}
//             />
//           </Grid>
//         </Grid>
//       </ContentSubHeader>
//     </>
//   );
// }

// export default HyPetMachineView;
